<template lang="pug">
aside.dm-corp-dialog(:class="{'show': show}" @click="clickOver")
  .dialog-inner(@click.stop="")
    .dialog-title(v-if="title") 在线调试
      span.icon-close
        i.dmico-icon-close
    .dialog-body
      slot 暂无内容
</template>

<script>
export default {
  name: 'Dialog',

  props: {
    title: { type: String },
    show: { type: Boolean, default: false }
  },

  data() {
    return {
      autoHideTimer: null
    }
  },

  methods: {
    clickOver() {
      this.$emit('update:show', false)
    }
  },

  beforeDestroy() {}
}
</script>

<style lang="scss">
@import '../../styles/variables';

aside.dm-corp-dialog {
  @include absFullSpread;
  position: fixed;
  z-index: -10;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;

  transition: opacity 0.3s;

  &.show {
    opacity: 1;
    visibility: visible;
    z-index: 900;
  }

  .dialog-inner {
    margin: 0;
    padding: 0;
    color: $text-primary;
    line-height: 1.5;
    background-color: #fff;
    -webkit-background-clip: content;
    border-radius: 2px;
    box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.2);
  }

  .dialog-title {
    position: relative;
    padding: 0 80px 0 20px;
    height: 42px;
    line-height: 42px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    overflow: hidden;
    background-color: #f8f8f8;
    border-radius: 2px 2px 0 0;
  }

  .icon-close {
    position: absolute;
    right: 10px;
    top: 0;
    height: 40px;
    padding: 12px 3px;
    font-size: 0;
    line-height: 0;
    cursor: pointer;
    i {
      transform: scale(0.8);
    }
  }

  .dialog-body {
    position: relative;
  }
}
</style>
